import { CommonModule } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { FaqEntryVO, PageViewApiService, PageVO } from "@core/api/v1";
import { CardModule } from "primeng/card";

@Component({
    selector: 'app-search-results',
    standalone: true,
    imports: [
        CardModule, CommonModule, RouterLink,
    ],
    templateUrl: './search-results.component.html',
    styleUrl: './search-results.component.scss',
})
export class SearchResultsComponent implements OnInit {

    constructor(private api: PageViewApiService, private route: ActivatedRoute) {
    }

    results: PageVO[];
    resultFaq: FaqEntryVO[];
    begriff: string | null;
    maxLength: number;
    lengthPages: number;
    lengthFaq: number;
    anzahl: number = 10;

    isSearchTouched = false;

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            console.log(this.isSearchTouched);
            this.begriff = params.get('s');
            if (this.begriff === null) {
                this.isSearchTouched = true;
                console.log(this.isSearchTouched);
            }
        });

        if (this.begriff === null) {
            this.lengthPages = 0;
            this.lengthFaq = 0;
            return;
        }
        this.api.searchLimitedPageResults(this.begriff, this.anzahl).subscribe(response => {
            this.results = response;
            this.lengthPages = response.length;
            console.log(this.lengthPages);
        });

        this.api.searchLimitedFaqResults(this.begriff, this.anzahl).subscribe(response => {
           this.resultFaq = response;
           this.lengthFaq = response.length;
           console.log(this.lengthFaq);
        });

        this.api.getCount(this.begriff).subscribe(res => {
            this.maxLength = res;
            console.log(this.maxLength);
        });
    }

    loadMore() {
        this.anzahl += 10;

        this.route.queryParamMap.subscribe(params => {
            this.begriff = params.get('s');
        });

        if (this.begriff === null) {
            return;
        }

        this.api.searchLimitedPageResults(this.begriff, this.anzahl).subscribe(response => {
            this.results = response;
            this.lengthPages = response.length;
        })

        this.api.searchLimitedFaqResults(this.begriff, this.anzahl).subscribe(response => {
            this.resultFaq = response;
            this.lengthFaq = response.length;
        });
    }

}
